export default {
  cancelText: 'Cancel'
};
